import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

export default createStore({
  state: {
    access_token: null,
    id_token: null,
    refresh_token: null,
  },
  getters: {
    access_token: state => state.access_token,
    id_token: state => state.id_token,
    refresh_token: state => state.refresh_token,
  },
  mutations: {
    setAccessToken(state, access_token) {
      state.access_token = access_token;
    },
    setIdToken(state, id_token) {
      state.id_token = id_token;
    },
    setRefreshToken(state, refresh_token) {
      state.refresh_token = refresh_token;
    },
  },
  actions: {

  },
  modules: {
  },
  plugins: [createPersistedState()],
})
